
import ReceiptItem from "../../../assets/duotone/ReceiptItem.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptItemIcon({ className, dataTestid = "ReceiptItemIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptItem data-testid={dataTestid} className={classes} {...rest} />
  );
}
